/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

const Colors = React.lazy(() => import('./index'));

const ColorSkeleton = () => (
  <div className="grid colors-skeleton-content">
    <h2 className="colors-skeleton-title sui-pb-2 sui-h2-bold sui-h2-bold-clean sui-line-clamp-unset sui-font-normal sui-text-primary">
      Colors
    </h2>
    <div className="sui-flex sui-flex-row">
      <div className="colors-skeleton-left">
        <div className="sui-grid  sui-gap-4">
          <Skeleton grow>
            {[...Array(4)].map(() => (<SkeletonLine fullWidth variant="multi" numberOfLines={4} />))}
          </Skeleton>
        </div>
      </div>
      <div className="colors-skeleton-right">
        <div id="swatch-container" className="swatchContainer collapsed" style={{ height: 'auto' }}>
          {[...Array(14)].map(() => (
            <Skeleton>
              <SkeletonBlock />
              <SkeletonLine />
            </Skeleton>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const ColorsSuspense = (props) => {
  if (typeof window === 'undefined') return <ColorSkeleton />;

  return (
    <Suspense fallback={<ColorSkeleton />}>
      <Colors {...props} />
    </Suspense>
  );
};
